import Api from '../Api'

import { createAction } from 'redux-actions'

export const REQUEST_NOTIFICATIONS = createAction('REQUEST_NOTIFICATIONS')
export const RECEIVE_NOTIFICATIONS = createAction('RECEIVE_NOTIFICATIONS')

export const fetchNotifications = (limit, offset) => {
  return (dispatch) => {
    dispatch(REQUEST_NOTIFICATIONS())

    return dispatch(RECEIVE_NOTIFICATIONS(Api.getNotifications(limit, offset)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/notifications.js